<div class="container-fluid">

    <div class="pageheader d-flex align-items-center justify-content-between mb-2">
        <h4 class="d-flex align-items-center mb-1">
               Scans
         </h4>
    </div>

      <div *ngFor="let file of files"
        (dblclick)="dblClickItem(file)">
      <app-unassigned-file #fileitem [details]="file" [selectable]="allowMultiSelect"></app-unassigned-file>
    </div>
  </div>

